import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as constants from '../../components/common/constants.js'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const state = {
  SelectedcontentId: '',
  CourseDetails: {},
  CurrentCourse: {}
}
const getters = {
  getSelectedcontentId: function (state) {
    return state.SelectedcontentId
  },
  getCourseDetails: function (state) {
    return state.CourseDetails
  },
  getCurrentCourse: function (state) {
    return state.CurrentCourse
  }
}
const mutations = {
  setSelectedcontentId (state, data) {
    state.SelectedcontentId = data
  },
  setCourseDetails (state, data) {
    state.CourseDetails = data
  },
  setCurrentCourse (state, data) {
    state.CurrentCourse = data
  }
}
const actions = {
  setCurrentCourse (context, data) {
    context.commit('setCurrentCourse', data)
  },
  getCourseDetails (context, Id) {
    axios
      .post('o/getlodetails', {
        'contentId': Id
      })
    .then(response => {
      context.commit('setCourseDetails', response.data)
      window.location.href = '#/coursePage'
    })
    .catch(e => {
      console.log(e)
    })
    window.location.href = '#/coursePage'
  // this.$router.push({path: '/searchPageAlt'})
  },
  checkExpiryDateForCO (context, data) {
    return new Promise((resolve, reject) => {
      axios.post('/r/viewItemValidityStatus', {
        'contentId': data.contentId,
        'profileId': context.getters.getProfileDetails.profileId
      }).then(response => {
        // alert(response.data)
        if (response.data === constants.NOT_EXPIRED_STATUS) {
          context.dispatch('goToERACoursePage', data)
        } else {
          Vue.toasted.error('Course Has Expired')
        }
        resolve()
      }).catch(err => {
        // this.$toasted.error(err)
        Vue.toasted.error('Something went wrong !')
        // Vue.toasted.error(err)
        reject(err)
      })
    })
  },
  goToERACoursePage (context, data) {
    // alert(context.getters.getProfileDetails)
    return new Promise((resolve, reject) => {
      axios.post(constants.ERA_GATEWAY_URL, {
        'learnerID': context.getters.getProfileDetails.profileId,
        // 'CourseID': course.contentId
        'learnerType': constants.ERA_LEARNER_TYPE
      })
        .then(response => {
          var courseUrl = response.data.baseurl
          // alert(courseUrl)
          // alert(JSON.stringify(response.data))
          axios.post('/r/coreemalogin/eraauthentication', {'courseID': data.contentId, 'serverURL': response.data.serverurl}).then(response => {
            delete response.data.eraCourseURL
            window.sessionStorage.setItem('eraData', JSON.stringify(response.data))
            // console.log(JSON.stringify(response.data))
            // location.href = window.location.origin + constants.ERA_COURSE_URL
            location.href = courseUrl
          }).catch(error => {
            alert('era' + error)
          })
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}
export default {
  state,
  actions,
  getters,
  mutations,
  plugins: [createPersistedState({ storage: window.localStorage })]
}



// WEBPACK FOOTER //
// ./src/store/modules/courseDetails.js